import {
    onMounted,
    onUnmounted,
} from '@vue/composition-api';

export function useKeydownEventListener(handleKeydown: (e: KeyboardEvent) => void) {
    onMounted(() => {
        document.addEventListener('keydown', handleKeydown);
    });

    onUnmounted(() => {
        document.removeEventListener('keydown', handleKeydown);
    });
}
